export const CUSTOMER_TYPE = [
  {
    label: "Customer",
    value: "1",
  },
  {
    label: "Visitor",
    value: "2",
  },
];

export const RENDER_CUSTOMER_TYPE = (key) => {
  switch (key) {
    case "1":
      return {
        label: "Customer",
      };
    case "2":
      return {
        label: "Visitor",
      };
    default:
      return {
        label: "",
      };
  }
};

export const RACE = [
  {
    label: "Thai",
    value: "1",
  },
  {
    label: "Foreigner",
    value: "2",
  },
];

export const RENDER_RACE = (key) => {
  switch (key) {
    case "1":
      return {
        label: "Thai",
      };
    case "2":
      return {
        label: "Foreigner",
      };
    default:
      return {
        label: "",
      };
  }
};

export const BOOKING_METHOD = [
  {
    label: "Walk in - member",
    value: "1",
  },
  {
    label: "Walk in - apply member",
    value: "2",
  },
  {
    label: "Walk in - no apply",
    value: "3",
  },
];

export const RENDER_BOOKIN_METHOD = (key) => {
  switch (key) {
    case "1":
      return {
        label: "Walk in - member",
      };
    case "2":
      return {
        label: "Walk in - apply member",
      };
    case "3":
      return {
        label: "Walk in - no apply",
      };
    default:
      return {
        label: "",
      };
  }
};

export const ENTRY_TYPE = [
  {
    label: "Walk in",
    value: "1",
  },
  {
    label: "Dealers",
    value: "2",
  },
];

export const RENDER_ENTRY_TYPE = (key) => {
  switch (key) {
    case "1":
      return {
        label: "Walk in",
      };
    case "2":
      return {
        label: "Dealers",
      };
    default:
      return {
        label: "",
      };
  }
};

export const PURPOSE_OPTION = [
  {
    label: "Education",
    value: "1",
  },
  {
    label: "Hobby",
    value: "2",
  },
  {
    label: "Business",
    value: "3",
  },
  {
    label: "Work",
    value: "4",
  },
];

export const RENDER_PURPOSE_OPTION = (key) => {
  switch (key) {
    case "1":
      return {
        label: "Education",
      };
    case "2":
      return {
        label: "Hobby",
      };
    case "3":
      return {
        label: "Business",
      };
    case "4":
      return {
        label: "Work",
      };
    default:
      return {
        label: "",
      };
  }
};

export const RENDER_TIME_OPTION = (startTime, endTime) => {
  const value = `${startTime},${endTime}`;
  const option = TIME_OPTION.find((item) => item.value === value);
  return option ? option.label : "";
};

export const TIME_OPTION = [
  { label: "10.00 - 11.00", value: "10.00,11.00" },
  { label: "11.00 - 12.00", value: "11.00,12.00" },
  { label: "13.00 - 14.00", value: "13.00,14.00" },
  { label: "14.00 - 15.00", value: "14.00,15.00" },
  { label: "15.00 - 16.00", value: "15.00,16.00" },
  { label: "16.00 - 17.00", value: "16.00,17.00" },
];

export const AGE_RANGE_OPTION = [
  {
    label: "3 - 12 ปี",
    labelEn: "3 - 12 years old",
    value: { start: 3, end: 12 },
  },
  {
    label: "13 - 18 ปี",
    labelEn: "13 - 18 years old",
    value: { start: 13, end: 18 },
  },
  {
    label: "19 - 24 ปี",
    labelEn: "19 - 24 years old",
    value: { start: 19, end: 24 },
  },
  {
    label: "25 - 34 ปี",
    labelEn: "25 - 34 years old",
    value: { start: 25, end: 34 },
  },
  {
    label: "35 - 44 ปี",
    labelEn: "35 - 44 years old",
    value: { start: 35, end: 44 },
  },
  {
    label: "45 - 54 ปี",
    labelEn: "45 - 54 years old",
    value: { start: 45, end: 54 },
  },
  {
    label: "55 - 64 ปี",
    labelEn: "55 - 64 years old",
    value: { start: 55, end: 64 },
  },
  {
    label: "65 ปีขึ้นไป",
    labelEn: "65+ years old",
    value: { start: 65, end: 0 },
  },
];

export const RENDER_AGE_RANGE_OPTION = (key) => {
  switch (key) {
    case "1":
      return {
        label: "10 - 20",
      };
    case "2":
      return {
        label: "21 - 30",
      };
    case "3":
      return {
        label: "31 - 40",
      };
    case "4":
      return {
        label: "41 - 50",
      };
    case "5":
      return {
        label: "51 - 60",
      };
    case "6":
      return {
        label: "60 and more",
      };
    default:
      return {
        label: "",
      };
  }
};

export const AWAREENESS_CHANNEL_OPTIONS = [
  {
    label: "Social Media Advertisement (Facebook or Instagram)",
    value: "1",
  },
  {
    label: "YouTube Advertisement",
    value: "2",
  },
  {
    label: "Search Engines or Websites (e.g., Google)",
    value: "3",
  },
  {
    label: "Word of Mouth (Friend, Acquaintance, or Family)",
    value: "4",
  },
  {
    label: "Existing Yamaha Product User",
    value: "5",
  },
  {
    label: "Attended Yamaha Event / Workshop",
    value: "6",
  },
  {
    label: "Received Info via Email, SMS, or LINE Official",
    value: "7",
  },
  {
    label: "Recommendation from Music Teacher or Music School",
    value: "8",
  },
  {
    label: "Other",
    value: "9",
  },
];
